<h1 class="h3-responsive text-center font-bold mt-20">
  <p>Our motto is</p>
  <p>"Honesty is the best policy"!</p>
</h1>

<!-- hero section -->
<section class="hero flex flex-col items-center justify-center gap-24">
  @for (itm of mottos; track $index) {
  <icon-title-desc>
    <img image [ngSrc]="itm.imageLink" alt="" width="95" height="95" />

    <ul title class="list-disc list-inside">
      <li class="font-bold h5-responsive text-primary">
        {{ itm.title }}
      </li>
    </ul>
    <p description class="h6-responsive font-thin text-gray-500">
      {{ itm.description }}
    </p>
  </icon-title-desc>
  }
</section>
